export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6946.5c97b32f.jpg";